namespace Nbs.Xlr8PageTemplate.Utilities {
  export function getNbsHeaderElement() {
    return getOrCreateElement('nbs-header', 'body', 'afterbegin', true) as HTMLElement;
  }

  export function getNbsFooterElement() {
    return getOrCreateElement('nbs-footer', 'body', 'beforeend', true) as HTMLElement;
  }

  export function getNbsMenuElement(): HTMLElement {
    const nbsMenuElement = getOrCreateElement('nbs-menu', 'nbs-header', 'afterend', false);
    if (nbsMenuElement) {
      return nbsMenuElement;
    }

    // for nbsMenuElement to be falsey here it means the nbs-menu AND nbs-header elements do not already exist in the dom
    // so, get the nbs-header, which should create it at the top of body
    // then try again to get the nbs-menu, which should now create directly after nbs-header
    getNbsHeaderElement();
    return getOrCreateElement('nbs-menu', 'nbs-header', 'afterend', true) as HTMLElement;
  }
}
